import { render, staticRenderFns } from "./OrderDetailItems.vue?vue&type=template&id=6e106af2&scoped=true&"
import script from "./OrderDetailItems.vue?vue&type=script&lang=js&"
export * from "./OrderDetailItems.vue?vue&type=script&lang=js&"
import style0 from "./OrderDetailItems.vue?vue&type=style&index=0&id=6e106af2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e106af2",
  null
  
)

export default component.exports